<div [ngStyle]="{'background-color': backgroundColor}" class="avatar">
  {{ initials }}
</div>
